export default __webpack_public_path__ + "static/media/gallery-img-2.b5051b27.jpg";